import { useUserContext } from '@fortem-monorepo/react-spa'

export interface CanAccessProps extends React.PropsWithChildren {
  permissions: string[]
}

/**
 * Show or hide UI based on permissions
 */
export const CanAccess: React.FC<CanAccessProps> = ({ permissions, children }) => {
  const { hasPermissions } = useUserContext()

  const hasAccess = hasPermissions(() => ({ permissions }))

  return hasAccess ? children : null
}
